var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _vm.employeeName
                    ? _c("span", [_vm._v(_vm._s(_vm.employeeName))])
                    : _c("v-progress-circular", {
                        attrs: { indeterminate: "", dark: "" }
                      })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { offset: "4", cols: "4" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Restdays",
                  items: _vm.restdaysList,
                  "item-value": "value",
                  "item-text": "text",
                  multiple: "",
                  size: "",
                  chips: "",
                  "small-chips": "",
                  "deletable-chips": ""
                },
                model: {
                  value: _vm.restdays,
                  callback: function($$v) {
                    _vm.restdays = $$v
                  },
                  expression: "restdays"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Rating",
                  chips: "",
                  "small-chips": "",
                  "auto-select-first": "",
                  items: ["fixed", "daily"]
                },
                model: {
                  value: _vm.rating,
                  callback: function($$v) {
                    _vm.rating = $$v
                  },
                  expression: "rating"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Monthly Rate", type: "number" },
                on: { keyup: _vm.monthlyRateKeyup },
                model: {
                  value: _vm.monthlyRate,
                  callback: function($$v) {
                    _vm.monthlyRate = $$v
                  },
                  expression: "monthlyRate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Daily Rate", type: "number" },
                on: { keyup: _vm.dailyRateKeyup },
                model: {
                  value: _vm.dailyRate,
                  callback: function($$v) {
                    _vm.dailyRate = $$v
                  },
                  expression: "dailyRate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Hourly Rate", type: "number" },
                on: { keyup: _vm.hourlyRateKeyup },
                model: {
                  value: _vm.hourlyRate,
                  callback: function($$v) {
                    _vm.hourlyRate = $$v
                  },
                  expression: "hourlyRate"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "SSS", type: "number" },
                model: {
                  value: _vm.sss,
                  callback: function($$v) {
                    _vm.sss = $$v
                  },
                  expression: "sss"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Pag-ibig", type: "number" },
                model: {
                  value: _vm.pagIbig,
                  callback: function($$v) {
                    _vm.pagIbig = $$v
                  },
                  expression: "pagIbig"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Philhealth", type: "number" },
                model: {
                  value: _vm.philhealth,
                  callback: function($$v) {
                    _vm.philhealth = $$v
                  },
                  expression: "philhealth"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", dark: "", block: "", rounded: "" },
                  on: { click: _vm.save }
                },
                [_vm._v(" Save ")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: { color: "red", dark: "", block: "", rounded: "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/employees")
                    }
                  }
                },
                [_vm._v(" Cancel ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }